module.exports = __webpack_public_path__ + "img/2769e8a.jpg";